
import { useState } from 'react';
import AdminHeader from './components/AdminHeader';
import Statistics from './components/Statistics';
import UserManagement from './components/UserManagement';
import CourseManagement from './components/CourseManagement';

export default function AdminPage() {
  const [activeTab, setActiveTab] = useState('statistics');

  return (
    <div className="min-h-screen bg-gray-50">
      <AdminHeader />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 sm:py-8">
        <div className="mb-4 sm:mb-6 flex gap-1 sm:gap-2 border-b border-gray-200 overflow-x-auto">
          <button
            onClick={() => setActiveTab('statistics')}
            className={`px-3 sm:px-6 py-2 sm:py-3 text-sm sm:text-base font-medium transition-colors whitespace-nowrap cursor-pointer ${
              activeTab === 'statistics'
                ? 'text-teal-600 border-b-2 border-teal-600'
                : 'text-gray-600 hover:text-gray-800'
            }`}
          >
            <i className="ri-bar-chart-line mr-1 sm:mr-2"></i>
            <span className="hidden sm:inline">Thống kê</span>
          </button>
          <button
            onClick={() => setActiveTab('users')}
            className={`px-3 sm:px-6 py-2 sm:py-3 text-sm sm:text-base font-medium transition-colors whitespace-nowrap cursor-pointer ${
              activeTab === 'users'
                ? 'text-teal-600 border-b-2 border-teal-600'
                : 'text-gray-600 hover:text-gray-800'
            }`}
          >
            <i className="ri-user-line mr-1 sm:mr-2"></i>
            <span className="hidden sm:inline">Quản lý người dùng</span>
            <span className="sm:hidden">Người dùng</span>
          </button>
          <button
            onClick={() => setActiveTab('courses')}
            className={`px-3 sm:px-6 py-2 sm:py-3 text-sm sm:text-base font-medium transition-colors whitespace-nowrap cursor-pointer ${
              activeTab === 'courses'
                ? 'text-teal-600 border-b-2 border-teal-600'
                : 'text-gray-600 hover:text-gray-800'
            }`}
          >
            <i className="ri-book-line mr-1 sm:mr-2"></i>
            <span className="hidden sm:inline">Quản lý khóa học</span>
            <span className="sm:hidden">Khóa học</span>
          </button>
        </div>

        {activeTab === 'statistics' && <Statistics />}
        {activeTab === 'users' && <UserManagement />}
        {activeTab === 'courses' && <CourseManagement />}
      </div>
    </div>
  );
}
